import React from 'react';
import Checkbox from '@mui/joy/Checkbox';

import { getIcon } from 'utils/misc';

type FancyCheckboxType = {
    size: 'sm' | 'md' | 'lg';
    label: string | React.ReactNode;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
}

export default function FancyCheckbox({size, label, checked, onChange, disabled=false}:FancyCheckboxType) {
    const Check = getIcon('Check');

    return (
        <Checkbox
            size={size}
            label={label}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            slotProps={{
                root: ({ checked, focusVisible }) => ({
                    sx: !checked
                        ? {
                            '& svg': { opacity: focusVisible ? 1 : 0 },
                            '&:hover svg': {
                                opacity: 1,
                            },
                        }
                        : undefined,
                }), }}
            uncheckedIcon={<Check />}
        />
    );
}
